import SetCoHost from './SetCoHost';

export default SetCoHost;
export * from './SetCoHost.type';
